import Head from 'next/head';
import Footer24 from '@/components/organisms/Footer24';
import Header24 from '@/components/organisms/Header24';

import { RenegociacaoTabs } from '@/data/misc/RenegociacaoTabs';
import React, { useState } from 'react';
import CustomTabs from '../CustomTabs';

import Styles from './TabGroupRenegociacao.css';
import Renegociacao25Banner from '@/components/organisms/Renegociacao25Banner';
import FaqLPs25 from '../FaqLPs25';
import Renegociacao25Blog from '@/components/organisms/Renegociacao25Blog';
import Renegociacao25 from '@/components/templates/Renegociacao25';
import Renegociacao25Emprestimos from '@/components/templates/Renegociacao25Emprestimos';
import Renegociacao25FinBanner from '@/components/organisms/Renegociacao25FinBanner';

function TabGroupRenegociacao({ tab }) {
  const [currentTab, setCurrentTab] = useState(tab);

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  const faqTitle =
    currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
      ? 'Saiba mais sobre o Portal Negocie+ e tire suas dúvidas'
      : 'Saiba mais sobre o Portal Quitejá e tire suas dúvidas';
  const imgpng =
    currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
      ? 'assets/renegociacao25/img-perguntas.png'
      : 'assets/renegociacao25-emp/img-perguntas.png';
  const imgwebp =
    currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
      ? 'assets/renegociacao25/img-perguntas.webp'
      : 'assets/renegociacao25-emp/img-perguntas.webp';
  const imgpngdesk =
    currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
      ? 'assets/renegociacao25/img-perguntas-desk.png'
      : 'assets/renegociacao25-emp/img-perguntas-desk.png';
  const imgwebpdesk =
    currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
      ? 'assets/renegociacao25/img-perguntas-desk.webp'
      : 'assets/renegociacao25-emp/img-perguntas-desk.webp';
  const imgalt =
    currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
      ? 'Mulher negra pesquisando com computador sobre como realizar uma renegociação ou reorganizar seu contrato do financiamento com o Santander.'
      : 'Pessoa com camisa vermelha com notebook em escritório, observando no site da Santander Financiamentos sua renegociação do contrato de empréstimo.';
  // const linkMostrarTodasPerguntas = 'duvidas-frequentes.html'; exemplo quando tem "Mostrar todas as perguntas"
  const faqs = [
    {
      pergunta:
        currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
          ? 'O que é o Portal Negocie+?'
          : 'O que é o Portal Quitejá?',
      resposta:
        currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
          ? `O Portal Negocie+ é uma plataforma online para
        você renegociar o seu financiamento em atraso. No Negocie+ é possível
        renegociar o seu contrato de financiamento, gerar o boleto atualizado das
        parcelas em atraso e quitar o seu financiamento de forma rápida, simples e
        100% online. * Sujeito a elegibilidade de ofertas.`
          : `O Portal Quitejá é uma plataforma online para
        você renegociar o seu financiamento em atraso. No Quitejá é possível
        renegociar o seu contrato de financiamento, gerar o boleto atualizado das
        parcelas em atraso e quitar o seu financiamento de forma rápida, simples e
        100% online. * Sujeito a elegibilidade de ofertas.`,
      startOpen: true,
    },
    {
      pergunta: 'Quais ofertas tenho para ficar em dia?',
      resposta: `Todos os clientes que estão em
        atraso podem atualizar seus boletos atrasados em um só. As demais ofertas,
        com outras condições dependem de elegibilidade.`,
    },
    {
      pergunta: 'Quais as vantagens de renegociar meu financiamento?',
      resposta: `As vantagens incluem:<br />
        •	Evitar o pagamento de juros e multas;<br />
        •	Ter o nome limpo, aumentando o score de crédito e proporcionando liberdade para adquirir outros bens, sem complicações;<br />
        •	O benefício principal é a rotina mais tranquila e sem dor de cabeça. Ao organizar sua vida financeira, é possível pagar as contas do mês, reservar uma parte para emergências, fazer planos e projetos, vivendo com mais liberdade e segurança.
      `,
    },
    {
      pergunta: 'Se eu renegociar meu contrato é preciso assinar aditivo contratual? ',
      resposta: `É necessária a assinatura de aditivo contratual devido alteração em algumas condições do contrato, como a alteração na data de vencimento, no valor da parcela e o próprio período de carência.`,
    },
    {
      pergunta: 'Serei cobrado de juros adicionais?',
      resposta: `Ao renegociar seu contrato, a taxa de juros continuará a mesma do contrato original. Mas, devido a incidência durante o prazo escolhido, suas parcelas podem ficar diferentes do que está acostumado a pagar. Você pode simular e alterar o prazo de pagamento para encontrar uma parcela que caiba no seu bolso. 
      `,
    },
    {
      pergunta: 'Tenho problema em receber meus boletos, como faço para acessá-los? ',
      resposta:
        currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id
          ? `Você pode solicitar segundas vias de seus boletos de renegociação no Negocie+ ou, após alguns dias da efetivação de sua renegociação, na Área do Cliente.`
          : `Você pode solicitar segundas vias de seus boletos de renegociação no Quitejá ou, após alguns dias da efetivação de sua renegociação, na Área do Cliente.`,
    },
  ];

  return (
    <>
      {currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id && (
        <Head>
          <title>Regularize seu contrato | Santander Financiamentos</title>
          <meta
            name="Description"
            content="Contrato em atraso? Renegocie no Santander Financiamentos. Contrato em dia? Conheça a reorganização. Soluções online para aliviar seu orçamento."
          />
          <meta name="robots" content="index,follow" />
          <meta
            name="keywords"
            content="Renegociação online, Renegociação de carro, Nome limpo, Quitar financiamento, Quitar financiamento Santander, Renegociação de dívidas, Boleto atualizado, Renegociar financiamento, Parcelas em atraso, Renegociação Santander Financiamentos, Reduzir parcela, Reorganização Santander, melhores condições para renegociar suas dividas"
          />
          <link
            rel="canonical"
            href="https://www.santander.com.br/hotsite/santanderfinanciamentos/renegociacao-santander-financiamentos.html"
          />
          {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
          <meta property="og:locale" content="pt_BR" />
          <meta property="og:title" content="Regularize seu contrato | Santander Financiamentos" />
          <meta
            property="og:url"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/renegociacao-santander-financiamentos.html"
          />
          <meta property="og:site_name" content="Santander Financiamentos" />
          <meta
            property="og:description"
            content="Contrato em atraso? Renegocie no Santander Financiamentos. Contrato em dia? Conheça a reorganização. Soluções online para aliviar seu orçamento."
          />
          <meta
            property="og:image"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/renegociacao25/separador-reneg-desk.webp"
          />
          <meta
            property="og:image:alt"
            content="Mluher branca dirigindo seu veículo após realizar uma renegociação com a Santander Financiamentos"
          />
          <meta property="og:image:type" content="image/webp" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="627" />
          <meta property="og:type" content="website" />

          {/* <!-- TWITTER CARDS FOR TWITTER --> */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Regularize seu contrato | Santander Financiamentos" />
          <meta
            name="twitter:description"
            content="Contrato em atraso? Renegocie no Santander Financiamentos. Contrato em dia? Conheça a reorganização. Soluções online para aliviar seu orçamento."
          />
          <meta
            name="twitter:url"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/renegociacao-santander-financiamentos.html"
          />
          <meta
            property="twitter:image"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/renegociacao25/separador-reneg-desk.webp"
          />
          <meta
            property="twitter:image:alt"
            content="Mulher branca dirigindo seu veículo após realizar uma renegociação com a Santander Financiamentos"
          />
          <meta property="twitter:image:type" content="image/webp" />
          <meta property="twitter:image:width" content="1200" />
          <meta property="twitter:image:height" content="627" />
        </Head>
      )}
      {currentTab === RenegociacaoTabs['renegociacao-santander-emprestimos'].id && (
        <Head>
          <title>Renegocie seu empréstimo | Santander Financiamentos</title>
          <meta
            name="Description"
            content="Contrato em dia ou atrasado? Santander Financiamentos oferece a solução certa para você. Renegocie ou reorganize seu contrato e facilite sua vida."
          />
          <meta name="robots" content="index,follow" />
          <meta
            name="keywords"
            content="Como renegociar financiamento de veiculo, Como renegociar financiamento de carro, Renegociação de financiamento de veículos, Como reorganizar dividas"
          />
          <link
            rel="canonical"
            href="https://www.santander.com.br/hotsite/santanderfinanciamentos/renegociacao-santander-emprestimos.html"
          />
          {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
          <meta property="og:locale" content="pt_BR" />
          <meta property="og:title" content="Renegocie seu empréstimo | Santander Financiamentos" />
          <meta
            property="og:url"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/renegociacao-santander-emprestimos.html"
          />
          <meta property="og:site_name" content="Santander Financiamentos" />
          <meta
            property="og:description"
            content="Renegocie seu empréstimo com garantia de veículo na Santander Financiamento: segurança, ofertas exclusivas e praticidade online."
          />
          <meta
            property="og:image"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/renegociacao25-emp/hero/hero-1440.webp"
          />
          <meta
            property="og:image:alt"
            content="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="627" />
          <meta property="og:type" content="website" />

          {/* <!-- TWITTER CARDS FOR TWITTER --> */}
          <meta name="twitter:card" content="" />
          <meta
            name="twitter:title"
            content="Renegocie seu empréstimo | Santander Financiamentos"
          />
          <meta
            name="twitter:description"
            content="Renegocie seu empréstimo com garantia de veículo na Santander Financiamento: segurança, ofertas exclusivas e praticidade online."
          />
          <meta
            name="twitter:url"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/renegociacao-santander-emprestimos.html"
          />
          <meta
            property="twitter:image"
            content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/renegociacao25-emp/hero/hero-1440.webp"
          />
          <meta
            property="twitter:image:alt"
            content="Pessoa com camisa vermelha, sentada à frente de um notebook em um ambiente claro, realizando uma renegociação do seu contrato de empréstimo com o Santander."
          />
          <meta property="twitter:image:type" content="image/png" />
          <meta property="twitter:image:width" content="1200" />
          <meta property="twitter:image:height" content="627" />
        </Head>
      )}
      <Header24 isHome24 />
      {currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id && (
        <>
          <Renegociacao25FinBanner />
        </>
      )}
      {currentTab === RenegociacaoTabs['renegociacao-santander-emprestimos'].id && (
        <>
          <Renegociacao25Banner currentTab={currentTab} />
        </>
      )}

      <CustomTabs initialTab={tab} tabs={RenegociacaoTabs} onTabChanged={handleTab} />

      <Renegociacao25
        show={currentTab === RenegociacaoTabs['renegociacao-santander-financiamentos'].id}
      />

      <Renegociacao25Emprestimos
        show={currentTab === RenegociacaoTabs['renegociacao-santander-emprestimos'].id}
      />

      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        // linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <Renegociacao25Blog />
      <Footer24 />
      {/* <Header24 />

      {currentTab === SeguroTabs['seguro-santander-auto'].id && <SeguroAuto25Banner />}
      {currentTab === SeguroTabs['cdc-protegido'].id && <CDCProtegido25Banner />}

      <CustomTabs
        initialTab={tab}
        tabs={SeguroTabs}
        onTabChanged={handleTab}
        className={currentTab === SeguroTabs['seguro-santander-auto'].id && 'tab-seguro-auto'}
      />

      {currentTab === SeguroTabs['seguro-santander-auto'].id && <SeguroAuto25 />}
      {currentTab === SeguroTabs['cdc-protegido'].id && <CDCProtegido25 />}

      <SegurosConteudos />
      <Footer24 /> */}
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupRenegociacao;
